export default {
    companyName: 'Copyright of Shanghai Dingchong New Energy Technology Co., Ltd.',
    // companyICP: 'Su ICPB 15008760-3',
    companyICP: 'Shanghai ICP Registration No. 15017026-3',
    // companyName_1: 'HT-Icharge Technology Co., Ltd',
    companyName_1: 'Shanghai Dingchong New Energy Technology Co., Ltd.',
    // address: 'No. 168 Jiaotong North Road, Wujiang District, Suzhou City, Jiangsu Province',
    address: 'Room JT11801, Building 2, No. 988, Jingtang Road, Nanxiang Town, Jiading District, Shanghai',
    telPhone: 'Email: icharge@hengtonggroup.com.cn',
    record: 'Registration number'
}


